import LabServiceCollection from "@/collections/LabServiceCollection";
import AttributeListModel from "@/models/lab/AttributeListModel";

export default class AttributeListCollection extends LabServiceCollection {
  model() {
    return AttributeListModel;
  }
}
